import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { loginApi } from '../api/http';

const AuthContext = createContext(null);
const storage = localStorage;

export function AuthProvider({ children }) {
  const [session, setSession] = useState(() => {
    try { return JSON.parse(storage.getItem('session')) ?? null; } catch { return null; }
  });

  const user  = session?.user  || null;
  const token = session?.token || null;

  useEffect(() => {
    const onForcedLogout = () => logout();
    window.addEventListener('auth:logout', onForcedLogout);
    return () => window.removeEventListener('auth:logout', onForcedLogout);
  }, []);

  //contra respuestas inesperadas del backend
  async function login(email, password) {
    const res = await loginApi(email, password); // esperado: { token, user }

    if (!res || typeof res !== 'object') {
      throw new Error('Respuesta de login inválida (sin cuerpo).');
    }
    // Soporta variantes { token, user } o { data:{ token, user } }
    const tk  = res.token ?? res?.data?.token;
    const usr = res.user  ?? res?.data?.user;

    if (!tk || !usr) {
      throw new Error('Respuesta de login inválida (falta token/usuario).');
    }

    const sess = { token: tk, user: usr };
    setSession(sess);
    try { storage.setItem('session', JSON.stringify(sess)); } catch {}
    return usr;
  }

  function logout() {
    setSession(null);
    storage.removeItem('session');
    if (typeof window !== 'undefined') {
      const currentHash = window.location.hash;
      if (!currentHash.startsWith('#/login')) {
        window.location.replace('/#/login');
      }
    }
  }

  const hasRole = useMemo(() => {
    return (roles) => {
      if (!user) return false;
      const arr = Array.isArray(roles) ? roles : [roles];
      return arr.includes(user.role) || (user.role === 'admin' && arr.includes('programmer'));
    };
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, token, login, logout, hasRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
